<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.dictCode ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
        <el-form-item label="分类名字" prop="dictName">
          <el-input v-model="dataForm.dictName" placeholder="分类名字"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
            <el-radio-group v-model="dataForm.type">
              <el-radio :label="0">电影</el-radio>
              <el-radio :label="1">小说</el-radio>
            </el-radio-group>
      </el-form-item>
      <el-form-item label="LOGO" prop="dictImg">
        <ImageUpload :limit="1"
          v-model="dataForm.dictImg"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
      </el-form-item>
      <el-form-item label="排序" prop="sorts">
          <el-input v-model="dataForm.sorts" placeholder="排列顺序 ,越小越靠前"></el-input>
      </el-form-item>
      <el-form-item label="首页推荐" prop="recommend">
            <el-radio-group v-model="dataForm.recommend">
              <el-radio :label="0">不推荐</el-radio>
              <el-radio :label="1">推荐</el-radio>
            </el-radio-group>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      imageType: ["jpg","jpeg","png","gif","bmp","webp"],
      visible: false,
      url:'',
      dictImg: '',
      dataForm: {
          // id: '',
        dictName: '',
        dictImg: '',
        recommend: '',
        dictCode: '',
        sorts:'',
        type: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        dictName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      console.log(111111111);
      
      this.url = `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/sys/oss/upload?token=${Cookies.get('token')}`
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        // console.log("nacos", this.dataForm)
        if (this.dataForm.id) {
            console.log(this.dataForm.id,'this.dataForm.id');
            
            this.dataForm.dictCode=this.dataForm.id
            this.getInfo()
        }

      })
    },
    beforeUploadHandle (file) {

       return true;
   },
       // 上传成功
   successHandle (fileList) {
     if(fileList.length>0){
       this.dictImg = fileList[0].url,
       this.dataForm.dictImg = this.dictImg
     }else{
       return this.$message.error("上传失败")
     }
   },
    // 获取信息
    getInfo () {
      this.$http.get(`/dict/dict/${this.dataForm.dictCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.dictCode ? 'post' : 'put']('/dict/dict/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.dataForm.dictCode = ''
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
